angular.module('zc')
  .component('zcIwConversionPrice', {
    templateUrl: '/templates/projects.iw/iw_conversion_price.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwConversionPriceController
  });

zcIwConversionPriceController.$inject = ['$scope', '$translate', 'InterestWidgetStats', 'ChartV2', 'areaChartV2Config', 'iwGraphOptions', 'currencies', 'lib'];
function zcIwConversionPriceController($scope, $translate, InterestWidgetStats, ChartV2, areaChartV2Config, iwGraphOptions, currencies, lib) {
  const vm = this;

  const currency = currencies[vm.project.currency];
  const tooltip = {
    valueSuffix: currency.suffix,
    valueDecimals: currency.fractionSize
  };

  const chart = new ChartV2(areaChartV2Config);
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        const conversionPriceData = [];
        const conversionPriceWithCampaignData = [];
        lib.accumulateCountMap(stats).forEach(stat => {
          stat = InterestWidgetStats.transform(stat);
          conversionPriceData.push([stat.start_at.valueOf(), stat.iw_click_item.conversion_price]);
          conversionPriceWithCampaignData.push([stat.start_at.valueOf(), stat.iw_click_item.conversion_price_with_campaign]);
        });
        chart.resetSeries();
        chart.addSeries({ name: $translate.instant('projectsIw.conversionPrice.conversionPriceData'), data: conversionPriceData, tooltip: tooltip });
        chart.addSeries({ name: $translate.instant('projectsIw.conversionPrice.conversionPriceWithCampaignData'), data: conversionPriceWithCampaignData, tooltip: tooltip });
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_conversion_price.js